import {
  Avatar,
  Card,
  CardActionArea,
  CardHeader,
  IconButton,
  Typography,
  Badge,
} from "@mui/material";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const DoctorCard = ({
  clinicId,
  doctor,
  index,
  showDetails,
  toggleDetails,
}) => {
  const getInitialLetter = (name) =>
    (name && doctor.first_name.charAt(0).toUpperCase()) || "";
  return (
    <li
      key={doctor.doctor_id}
      className="w-full md:w-6/12 xl:w-4/12 2xl:w-3/12  list-none"
    >
      <Card
        sx={{
          width: "100%",
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <CardActionArea>
          <CardHeader
            avatar={
              <StyledBadge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                variant="dot"
              >
                <Avatar
                  alt={getInitialLetter(doctor.first_name)}
                  src={`images/doctor/${doctor.doctorPicture}`}
                  sx={{ width: 56, height: 56 }} // Increased size of avatar
                />
              </StyledBadge>
            }
            action={
              <div onClick={() => toggleDetails(index)}>
                {/* <IconButton aria-label="settings"> */}
                <div aria-label="settings">
                  {showDetails[index] ? (
                    <MdOutlineExpandLess />
                  ) : (
                    <MdOutlineExpandMore />
                  )}
                </div>
                {/* </IconButton> */}
              </div>
            }
            title={
              <Link
                to={`/patient/?clinicId=${clinicId}&doctorId=${doctor.doctor_id}`}
                state={{
                  doctorNameProps: `${doctor.first_name} ${doctor.last_name}`,
                }}
                className="text-[#1D4ED8] hover:text-[#2E37A4]"
              >
                <Typography variant="subtitle2" component="div">
                  Dr. {doctor.first_name} {doctor.last_name}
                </Typography>
              </Link>
            }
            subheader={
              <Link
                to={`/patient/?clinicId=${clinicId}&doctorId=${doctor.doctor_id}`}
                className="text-gray-600 hover:text-gray-800"
              >
                <Typography variant="caption" component="div">
                  {doctor.doctor_speciality}
                </Typography>
              </Link>
            }
          />
          {showDetails[index] && (
            <div className="p-4 border-t border-gray-200">
              <Typography variant="body2" gutterBottom>
                <strong>Education:</strong> {doctor.doctor_qualification}
              </Typography>
            </div>
          )}
        </CardActionArea>
      </Card>
    </li>
  );
};

export default DoctorCard;
